/* tslint:disable */
import { defineMessages } from 'react-intl';

export default defineMessages({
    attention: {
        defaultMessage: 'attention',
        id: 'betslip.Error.attention',
    },

    inactive: {
        defaultMessage: 'Inactive',
        id: 'betslip.BetslipHeader.inactive',
    },
    inProcessingMobile: {
        defaultMessage: 'processing',
        id: 'betslip.BetslipHeader.inProcessingMobile',
    },
    inProcessing: {
        defaultMessage: 'Processing...',
        id: 'betslip.BetslipHeader.inProcessing',
    },
    completedMobile: {
        defaultMessage: 'completed',
        id: 'betslip.BetslipHeader.completedMobile',
    },
    completed: {
        defaultMessage: 'completed/success',
        id: 'betslip.BetslipHeader.completed',
    },

    // EXPRESS: {
    //     defaultMessage: 'EXPRESS',
    //     id: 'betslip.EXPRESS',
    // },
    // SINGLE: {
    //     defaultMessage: 'SINGLE',
    //     id: 'betslip.SINGLE',
    // },
    // SYSTEM: {
    //     defaultMessage: 'SYSTEM',
    //     id: 'betslip.SYSTEM',
    // },
    updatesSettingsTitle: {
        defaultMessage: 'Accept changes automatically?',
        id: 'betslip.UpdatesSettings.updatesSettingsTitle',
    },
    notificationSettingsTitle: {
        defaultMessage: 'Betslip notification settings',
        id: 'betslip.UpdatesSettings.notificationSettingsTitle',
    },
    updatesSettingsDescription: {
        defaultMessage:
            'Choose a betting strategy that is more convenient for you:',
        id: 'betslip.UpdatesSettings.updatesSettingsDescription',
    },
    acceptAll: {
        defaultMessage: 'Accept any odds changes',
        id: 'betslip.UpdatesSettings.acceptAll',
    },
    acceptAllQuestion: {
        defaultMessage: 'Accept any odds changes?',
        id: 'betslip.AcceptOddsChangeModal.acceptAllQuestion',
    },
    acceptHigher: {
        defaultMessage: 'Accept better odds only',
        id: 'betslip.UpdatesSettings.acceptHigher',
    },
    alwaysAsk: {
        defaultMessage: 'Always ask',
        id: 'betslip.UpdatesSettings.alwaysAsk',
    },
    deleteAllBetslipOdds: {
        defaultMessage: 'Delete All',
        id: 'betslip.BetslipHeader.deleteAllBetslipOdds',
    },
    oddsUpdates: {
        defaultMessage: 'Odds Updates',
        id: 'betslip.BetslipHeader.oddsUpdates',
    },
    minimize: {
        defaultMessage: 'Minimize',
        id: 'betslip.BetslipHeader.minimize',
    },
    freeBet: {
        defaultMessage: 'Free Bet',
        id: 'betslip.Odd.OddDetails.freeBet',
    },
    deleteOdd: {
        defaultMessage: 'Delete Odds',
        id: 'betslip.Odd.deleteOdd',
    },
    betPerOneGroup: {
        defaultMessage: 'Stake per bet',
        id: 'betslip.BetslipFooter.StakeRow.betPerOneGroup',
    },
    freeBetRow: {
        defaultMessage: 'FREEBET ON',
        id: 'betslip.BetslipFooter.FreeBetRow.freeBetRow',
    },
    combo: {
        defaultMessage: 'COMBO BONUS ACCUMULATOR',
        id: 'betslip.BetslipFooter.ExpressPart.ComboBonusRow.combo',
    },
    selectCombinations: {
        defaultMessage: 'Select Combinations',
        id: 'betslip.BetslipFooter.SystemPart.Combinations.selectCombinations',
    },
    combination: {
        defaultMessage: 'Combination',
        id: 'betslip.BetslipFooter.SystemPart.CombinationRow.combination',
    },
    openCombination: {
        defaultMessage: 'Open Combination',
        id: 'betslip.BetslipFooter.SystemPart.CombinationRow.openCombination',
    },
    totalOddExtraSmall: {
        defaultMessage: 'Total Odds',
        id: 'betslip.BetslipFooter.TotalRow.totalOddExtraSmall',
    },
    signInBet: {
        defaultMessage: 'Sign In & Bet',
        id: 'betslip.BetslipFooter.TotalRow.signInBet',
    },
    placeBetError: {
        defaultMessage: 'Bet place error.',
        id: 'betslip.Odd.Error',
    },
    maxButton: {
        defaultMessage: 'MAX',
        id: 'betslip.BetslipFooter.TotalRow.maxButton',
    },
    acceptButton: {
        defaultMessage: 'Accept',
        id: 'betslip.AcceptNewCoefModal.acceptButton',
    },
    declineButton: {
        defaultMessage: 'No',
        id: 'betslip.AcceptNewCoefModal.declineButton',
    },
    skipButton: {
        defaultMessage: 'Skip',
        id: 'betslip.AcceptOddsChangeModal.skipButton',
    },
    oddsStrategyHelpInfo: {
        defaultMessage:
            'You can always change the parameters set by the notice. To do this, click on the "{icon}" button and choose any other method convenient for you.',
        id: 'betslip.AcceptOddsChangeModal.oddsStrategyHelpInfo',
    },
    oddsChanged: {
        defaultMessage: 'Odds changed',
        id: 'betslip.AcceptOddsChangeModal.oddsChanged',
    },
    coefsHaveChanged: {
        defaultMessage: 'Coefficients or statuses have changed!',
        id: 'betslip.AcceptNewCoefModal.coefsChangedText',
    },
    errorMaxSystem: {
        defaultMessage: 'Maximum quantity of odds in system bet is 10.',
        id: 'betslip.Combinations.errorMaxExpress',
    },
    errorMaxStake: {
        defaultMessage: 'Max bet up to',
        id: 'betslip.Dropdown.error.maxStake',
    },
    betslipOddsHasConflicts: {
        id: 'betslip.GroupOfOdds.betslipOddsHasConflicts',
        defaultMessage: 'Restrictions apply to highlighted selections!',
    },
    limitIsExceeded: {
        id: 'betslip.BetslipFooter.TotalRow.limitIsExceeded',
        defaultMessage: 'Limit is exceeded',
    },
    insufficientFunds: {
        defaultMessage: 'Insufficient funds to place bet',
        id: 'betslip.Odd.Error.insufficientFunds',
    },
    stakeExceedsMaxBet: {
        defaultMessage: 'Stake is too big, try to decrease',
        id: 'betslip.Odd.Error.stakeExceedsMaxBet',
    },
    verifiedPlayerLimitCrossed: {
        defaultMessage: 'Verification request during processing. Please wait.',
        id: 'betslip.Odd.Error.verifiedPlayerLimitCrossed',
    },
    betslipRejected: {
        defaultMessage: 'Betslip rejected',
        id: 'betslip.Odd.Error.betslipRejected',
    },
    responseTimedOut: {
        defaultMessage: 'Internal error: response timed out',
        id: 'betslip.Odd.Error.responseTimedOut',
    },
    playerIpThisIsNotAValidIpAddress: {
        defaultMessage: 'This is not a valid IP address',
        id: 'betslip.Odd.Error.playerIpThisIsNotAValidIpAddress',
    },
    authCredentialsExpired: {
        defaultMessage: 'Your login credentials have expired, please re-login',
        id: 'betslip.Odd.Error.authCredentialsExpired',
    },
    authSessionUnknown: {
        defaultMessage: 'Session authentication failed, please try again',
        id: 'betslip.Odd.Error.authSessionUnknown',
    },
    betOnDifferentProviders: {
        defaultMessage:
            'This combination of selections is invalid. Please correct and try again',
        id: 'betslip.Odd.Error.betOnDifferentProviders',
    },
    betLimitExceeded: {
        defaultMessage: 'Bet limit exceeded',
        id: 'betslip.Odd.Error.betLimitExceeded',
    },
    bettingIsSuspended: {
        defaultMessage: 'Bets has been suspended on this event',
        id: 'betslip.Odd.Error.bettingIsSuspended',
    },
    internalErrorInvalidMatchStatus: {
        defaultMessage: 'Something went wrong with the match',
        id: 'betslip.Odd.Error.internalErrorInvalidMatchStatus',
    },
    internalErrorInvalidMarketStatus: {
        defaultMessage: 'Invalid market status',
        id: 'betslip.Odd.Error.internalErrorInvalidMarketStatus',
    },
    internalErrorInvalidOddStatus: {
        defaultMessage: 'Internal error: invalid price',
        id: 'betslip.Odd.Error.internalErrorInvalidOddStatus',
    },
    internalErrorInvalidOddsStatus: {
        defaultMessage: 'Selected outcome unavailable',
        id: 'betslip.Odd.Error.internalErrorInvalidOddsStatus',
    },
    stakeMinimalStakeIs: {
        defaultMessage: 'Minimal stake is:',
        id: 'betslip.Odd.Error.stakeMinimalStakeIs',
    },
    playerLimitCrossed: {
        defaultMessage: 'Wager limit you have set has been already reached',
        id: 'betslip.Odd.Error.playerLimitCrossed',
    },
    playerLimitCrossedDefault: {
        defaultMessage:
            'The action is prohibited due to the current restrictions for the player!',
        id: 'betslip.Odd.Error.playerLimitCrossedDefault',
    },
    internalError: {
        defaultMessage: 'An error occurred. Please try again later!',
        id: 'betslip.Odd.Error.internalError',
    },
    placeRetryLimitReached: {
        defaultMessage: 'Connection error. Please try again.',
        id: 'betslip.Odd.Error.placeRetryLimitReached',
    },
    identicalBetIsProcessing: {
        defaultMessage: 'Your bet on this outcome is processing at the moment',
        id: 'betslip.Odd.Error.identicalBetIsProcessing',
    },
    betIsForbidden: {
        defaultMessage: 'Bet is forbidden',
        id: 'betslip.Odd.Error.betIsForbidden',
    },
    betTypeIsForbidden: {
        defaultMessage: 'Bets of this type are forbidden at this moment',
        id: 'betslip.Odd.Error.betTypeIsForbidden',
    },
    betAmountRestrictionCrossed: {
        defaultMessage: 'bet amount restriction crossed',
        id: 'betslip.Odd.Error.betAmountRestrictionCrossed',
    },
    betType: {
        defaultMessage:
            'This type of bet is not permitted. Delete this selection',
        id: 'betslip.OddContainer.betType',
    },
    maxBet: {
        defaultMessage: 'Match limit exceeded. Try betting on other matches',
        id: 'betslip.OddContainer.maxBet',
    },
    betInterval: {
        defaultMessage:
            'Bet declined. Please try again in {timeToWait} seconds',
        id: 'betslip.OddContainer.betInterval',
    },

    selectionValue: {
        defaultMessage: 'Odd has changed. Please try again.',
        id: 'betslip.OddContainer.selectionValue',
    },

    sportEventStatus: {
        defaultMessage: 'Selected event is not available',
        id: 'betslip.OddContainer.sportEventStatus',
    },

    sportEventExistence: {
        defaultMessage: 'Selected event is not found',
        id: 'betslip.OddContainer.sportEventExistence',
    },

    marketStatus: {
        defaultMessage: 'Selected market is not available in the moment',
        id: 'betslip.OddContainer.marketStatus',
    },

    marketExistence: {
        defaultMessage: 'Selected market is not found',
        id: 'betslip.OddContainer.marketExistence',
    },

    marketDefective: {
        defaultMessage: 'Selected market is incorrect',
        id: 'betslip.OddContainer.marketDefective',
    },

    oddStatus: {
        defaultMessage: 'Odd status is not available',
        id: 'betslip.OddContainer.oddStatus',
    },

    oddExistence: {
        defaultMessage: 'Odd status is not found',
        id: 'betslip.OddContainer.oddExistence',
    },
    error: {
        defaultMessage: 'Error',
        id: 'betslip.BetslipHeader.error',
    },
    playerRequiredRequisites: {
        defaultMessage:
            'Please enter your personal information in your profile',
        id: 'betslip.Odd.Error.playerRequiredRequisites',
    },
    gamblerBlocked: {
        defaultMessage: 'Wager limit you have set has been already reached',
        id: 'betslip.Odd.Error.gamblerBlocked',
    },
    betRateLimitReached: {
        defaultMessage: 'Too many bets, wait a bit',
        id: 'betslip.Odd.Error.betRateLimitReached',
    },
    marketIsDefective: {
        defaultMessage: 'Group of outcomes is unavailable',
        id: 'betslip.Odd.Error.marketIsDefective',
    },
    freebetAlreadyUsed: {
        defaultMessage: 'Freebet has already been used in another bet',
        id: 'betslip.Odd.Error.freebetAlreadyUsed',
    },
    freebetExpired: {
        defaultMessage: 'This freebet has expired =(',
        id: 'betslip.Odd.Error.freebetExpired',
    },
    freebetInvalidStatus: {
        defaultMessage: 'Something is wrong with this freebet. Contact support',
        id: 'betslip.Odd.Error.freebetInvalidStatus',
    },
    freebetNotFound: {
        defaultMessage: 'Freebet not found',
        id: 'betslip.Odd.Error.freebetNotFound',
    },
    freebetNotApplicableContext: {
        defaultMessage:
            'Outcomes in this coupon do not qualify for the freebet. Try other outcomes described in the freebet rules.',
        id: 'betslip.Odd.Error.freebetNotApplicableContext',
    },
    deKycDeposit: {
        defaultMessage:
            'Please undergo the verification procedure so you can continue to place bets.',
        id: 'betslip.Odd.Error.deKycDeposit',
    },
    refillBalanceTitle: {
        defaultMessage: 'Пополни счет для этой ставки',
        id: 'betslip.RefillBalanceModal.refillBalanceTitle',
    },
    refillBalanceMessage: {
        defaultMessage:
            'Не хватает денег на счету. Для ставки на эту сумму пополнись на {balance}',
        id: 'betslip.RefillBalanceModal.refillBalanceMessage',
    },
    refill: {
        defaultMessage: 'Пополниться',
        id: 'betslip.RefillBalanceModal.refil',
    },
    placeBetStake: {
        defaultMessage: 'Поставить {stake}',
        id: 'betslip.RefillBalanceModal.placeBetStake',
    },
});
